
export const FBT_PATH = '/fbt'

export default {
  FBT_PATH,
}
